import { NgModule } from '@angular/core';
import { CommonModule as AngularCore } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
  CoreModule,
  ModalPanelComponent, PageActionPanelComponent,
  PostalCodeValidatorDirective,
  StickyPanelBottomComponent,
  StickyPanelBottomContentComponent
} from '@tdwb/core';
import { WebbrokerCoreModule } from '@tdwb/webbroker/core';
import { CurrentAgreementsModalComponent } from './current-agreements.modal.component';
import { AmexAgreementComponent } from './amex-agreement.component';
import { CegAgreementComponent } from './ceg-agreement.component';
import { MeAgreementComponent } from './me-agreement.component';
import { NasdaqAgreementComponent } from './nasdaq-agreement.component';
import { OpraAgreementComponent } from './opra-agreement.component';
import { TdAgreementComponent } from './td-agreement.component';
import { NyseAgreementComponent } from './nyse-agreement.component';
import { UsotcAgreementComponent } from './usotc-agreement.component';
import { CmeAgreementComponent } from './cme-agreement.component';
import { RusselAgreementComponent } from './russel-agreement.component';
import { IexAgreementComponent } from './iex-agreement.component';
import { TitleNeedsNameValidatorDirective } from './title-needs-name-validator.directive';

@NgModule({
  imports: [
    AngularCore,
    CoreModule,
    WebbrokerCoreModule,
    TranslateModule.forChild(),
    PostalCodeValidatorDirective,
    ModalPanelComponent,
    StickyPanelBottomComponent,
    StickyPanelBottomContentComponent,
    PageActionPanelComponent
  ],
  exports: [
    CurrentAgreementsModalComponent,
    AmexAgreementComponent,
    CegAgreementComponent,
    MeAgreementComponent,
    NasdaqAgreementComponent,
    NyseAgreementComponent,
    OpraAgreementComponent,
    TdAgreementComponent,
    UsotcAgreementComponent,
    CmeAgreementComponent,
    RusselAgreementComponent,
    IexAgreementComponent,
    TitleNeedsNameValidatorDirective
  ],
  declarations: [
    CurrentAgreementsModalComponent,
    AmexAgreementComponent,
    CegAgreementComponent,
    MeAgreementComponent,
    NasdaqAgreementComponent,
    NyseAgreementComponent,
    OpraAgreementComponent,
    TdAgreementComponent,
    UsotcAgreementComponent,
    CmeAgreementComponent,
    RusselAgreementComponent,
    IexAgreementComponent,
    TitleNeedsNameValidatorDirective
  ]
})
export class CurrentAgreementsModule {
}

export {
  CurrentAgreementsModalComponent,
  AmexAgreementComponent,
  CegAgreementComponent,
  MeAgreementComponent,
  NasdaqAgreementComponent,
  NyseAgreementComponent,
  OpraAgreementComponent,
  TdAgreementComponent,
  UsotcAgreementComponent,
  CmeAgreementComponent,
  RusselAgreementComponent,
  IexAgreementComponent,
  TitleNeedsNameValidatorDirective
};
